module.exports = __webpack_public_path__ + "img/logo-code.51328fed.png";